<template>
    <div @click.stop class="popover-container">

        <div @click="handlePopoverClick" class="popover" :class="[type, {'is-active': isActive}]">
            <slot></slot>
        </div>

        <div @click="toggle" class="popover-overlay"></div>

        <div @click="toggle" class="popover-trigger">
            <slot name="trigger"></slot>
        </div>

    </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'popover-top',
    },

    closeOnClick: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    Event.listen('closePopover', () => {
      this.isActive = false;
    });
  },

  data() {
    return {
      isActive: this.active,
    };
  },

  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },

    handlePopoverClick() {
      if (this.closeOnClick) {
        this.toggle();
      }
    },
  },
};
</script>